import createIcon from '../../createIcon';

/**
 * @component @name UnfoldMore
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuMDAwMiA1LjgzTDE1LjE3MDIgOUwxNi41ODAyIDcuNTlMMTIuMDAwMiAzTDcuNDEwMTYgNy41OUw4LjgzMDE2IDlMMTIuMDAwMiA1LjgzWk0xMi4wMDAyIDE4LjE3TDguODMwMTYgMTVMNy40MjAxNiAxNi40MUwxMi4wMDAyIDIxTDE2LjU5MDIgMTYuNDFMMTUuMTcwMiAxNUwxMi4wMDAyIDE4LjE3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const UnfoldMore = createIcon('UnfoldMore', [
  [
    'path',
    {
      d: 'M12.0002 5.83L15.1702 9L16.5802 7.59L12.0002 3L7.41016 7.59L8.83016 9L12.0002 5.83ZM12.0002 18.17L8.83016 15L7.42016 16.41L12.0002 21L16.5902 16.41L15.1702 15L12.0002 18.17Z',
      key: '1hgj27',
    },
  ],
]);

export default UnfoldMore;
